<ng-template appInflatorContainer></ng-template>
